/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { NDC_DETAILS_TAB_DATA } from '../../../utility/constants';
import CMSCOD from '../CMSCOD';
import CMSDESI from '../CMSDESI';
import CMSDrug from '../CMSDrug';
import CMSUROA from '../CMSUROA';
import Price from '../Price';
import TabNDCDetail from '../TabNDCDetail';
import NDCDetailsTab from './NDCDetailsTab';
import { getNDCValue } from '../NDCDetailsHeaderDetailsComponent';
import {
  setNDCSuccessMessage,
} from '../../../store/action';

const NDCDetailsTabSection = ({ fullScreen, setFullScreen }) => {
    const dispatch = useDispatch();
  
  const [tabSelected, setTabSelected] = useState(NDC_DETAILS_TAB_DATA[0].value);
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const currentNDCDetailsIndex = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsIndex
  );

  const ndcTabKey =
    getNDCValue(currentNDCDetailsSelected) || `page-${currentNDCDetailsIndex}`;

  const generalSystemParameterDetails = useSelector(
    (state) => state?.sharedState?.ndc?.generalSystemParameter?.paramGeneralVO
  );

  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);
  const [fullSFGrid, setFullSFGrid] = useState(false);
  const [fullSFTab, setFullSFTab] = useState(false);

  const resetFilter = () => {
    gridApi && gridApi.setFilterModel(null);
    setApplyFilter(false);
  };

  useEffect(() => {
    resetFilter();
  }, [tabSelected]);

  return (
    <>
      {!fullScreen && (
        <>
          <NDCDetailsTab
            childRef={childRef}
            gridApi={gridApi}
            columnApi={columnApi}
            tabData={NDC_DETAILS_TAB_DATA.filter((item) => {
              if (generalSystemParameterDetails?.[0]?.hideCmsUraInd !== 1) {
                return item;
              } else if (
                generalSystemParameterDetails?.[0]?.hideCmsUraInd === 1
                // &&
                // item.value !== 'cms_uroa'
              ) {
                return item;
              }
            })}
            tabValue={tabSelected}
            handleChangeTabValue={(e, value) => {
              dispatch(setNDCSuccessMessage(null));
              setTabSelected(value)}
            }
            fullScreen={fullScreen}
            applyFilter={applyFilter}
            resetFilter={resetFilter}
            setFullScreen={setFullScreen}
          />{' '}
        </>
      )}

      <div className='mt-1 container mw-100 px-0'>
        {tabSelected === NDC_DETAILS_TAB_DATA[0].value ? (
          <CMSDrug
            key={`cms-drug-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : tabSelected === NDC_DETAILS_TAB_DATA[1].value ? (
          <CMSUROA
            key={`cms-uroa-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : tabSelected === NDC_DETAILS_TAB_DATA[2].value ? (
          <CMSCOD
            key={`cms-cod-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : tabSelected === NDC_DETAILS_TAB_DATA[3].value ? (
          <CMSDESI
            key={`cms-desi-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : tabSelected === NDC_DETAILS_TAB_DATA[4].value ? (
          <TabNDCDetail
            key={`ndc-detail-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        ) : (
          <Price
            key={`price-${ndcTabKey}`}
            childRef={childRef}
            gridApi={gridApi}
            setGridApi={setGridApi}
            columnApi={columnApi}
            setColumnApi={setColumnApi}
            setApplyFilter={setApplyFilter}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        )}
      </div>
    </>
  );
};

export default NDCDetailsTabSection;
